import styled from '@emotion/styled'
import { ModalContent, Tr } from '@chakra-ui/react'

export const SenderTargetFormWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    min-width: 400px;
`

export const SenderTargetRow = styled(Tr,{
    shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isEven"
  })`
    ${({ isSelected }) => (isSelected ? 'color: var(--chakra-colors-whiteAlpha-900);' : '')};
    background-color: ${({ isSelected, isEven }) => (isSelected ? 'var(--chakra-colors-selected-row-background)' : isEven ? 'var(--chakra-colors-background)' : 'var(--chakra-colors-odd-background)')};

    & > td {
        border-bottom: none;
        padding-top: var(--chakra-space-3);
        padding-bottom: var(--chakra-space-3);
    }
`

export const AddSessionModalContent = styled(ModalContent)`
    background-color: var(--chakra-colors-modal);
    padding: 0px 20px 20px 20px;
    width: 750px;
`
